import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { MenuService } from './menu.service';
@Injectable({
  providedIn: 'root'
})
export class DebugService {
  debug : boolean = false;
  screenLayouts = [ 'dashboard','idle','default','quickveto','quickaction','waterpressure','settingsvalue','toast','help','loadinganimation','menu'];
  currentScreenLayout = 'dashboard';
  constructor(private menuService: MenuService) {
  	this.debug = (!environment.production);
  	//this.currentScreenLayout = this.menuService.getCurrentNode().getType();
  }
  switchScreenLayout(){
  	let idx = this.screenLayouts.indexOf(this.currentScreenLayout);
  	idx = (idx + 1)%this.screenLayouts.length;
  	this.currentScreenLayout = this.screenLayouts[idx];
  	this.menuService.getCurrentNode().setType(this.currentScreenLayout);
  }
}
